var appointments =
    [
        {
            "id": 1,
            "problemType": "Teeth Orthodontics",
            "time": "08:00 am - 09:00 am"
        },
        {
            "id": 2,
            "problemType": "Cosmetic Dentistry",
            "time": "10:00 am - 11:30 am"
        },
        {
            "id": 3,
            "problemType": "Teeth Cleaning",
            "time": "05:00 pm - 06:30 pm"
        },
        {
            "id": 4,
            "problemType": "Cavity Protection",
            "time": "07:00 pm - 08:00 pm"
        },
        {
            "id": 5,
            "problemType": "Teeth Orthodontics",
            "time": "08:00 pm - 09:00 pm"
        },
        {
            "id": 6,
            "problemType": "Cavity Protection",
            "time": "09:00 pm - 10:00 pm"
        }
    ];

export default appointments;